module.exports = __webpack_public_path__ + "img/wanji.5042ebfc.png";